import * as React from 'react';
import { Icons } from '@shared/ui-components';

import { Styled } from './styled';

export const SpinnerPage: React.SFC = () => {
  return (
    <Styled.Container>
      <Styled.Spinner><Icons.Loader /></Styled.Spinner>
    </Styled.Container>
  );
};
